const ConfirmDeletingDriver = 'ConfirmDeletingDriver';

export default {
  ConfirmDeletingDriver,
};
